
import dayjs from 'dayjs';

export const getDateStart = () => {
    return dayjs()
        .subtract(30, 'day')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss');
};

export const getTimeStampStart = () => {
    return dayjs()
        .subtract(30, 'day')
        .startOf('day')
};

export const getTimeStampEnd = () => {
    return dayjs()
        .endOf('day')
};

export const getDateEnd = () => {
    return dayjs()
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss');
};


export const pickerOptions = {
    disabledDate(v) {
        return v.getTime() < getTimeStampStart() || v.getTime() > getTimeStampEnd()
    },
};

